var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.promotions),function(promo,index){return _c('div',{key:index},[_c(_vm.getComponent(promo.RuleType),{tag:"component",attrs:{"promo":promo},on:{"delete":function($event){return _vm.handleDelete(index)},"edit":function($event){return _vm.handleEdit(index)}}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }